/* eslint-disable no-unused-vars */
import React, { useState, Suspense } from 'react'
import StepWizard from 'react-step-wizard'
import { Grid } from '@material-ui/core'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { useAsistencia } from '../../../../context/AsistenciaContext'
import { AsistenciaSeccion1View } from './AsistenciaSeccion1'
import { AsistenciaSeccion2View } from './AsistenciaSeccion2'
import { AsistenciaSeccion3View } from './AsistenciaSeccion3'
import { useHistory } from 'react-router-dom'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import { LoadingButton } from '@mui/lab'
import { useFormTechnicalAssistance } from '../../../../context/TechnicalAssistanceContext'
import { useAuthentication } from '../../../../context/authenticationContext'
import {
  reportCapacityBuilding,
  reportCapacityBuildingGroupMipyme,
  reportCapacityBuildingIFI,
  reportTechnicalAssistancePreinvestment,
  reportTechnicalAssistancePreinvestmentGroupMipyme,
} from '../../../../services/AsistenciaTecnica/create'
import ROUTES from '../../../../routers/routes'

const AsistenciaTecnicaFormView = ({ idForm }) => {
  const [state, dispatch, enableSec3, setEnableSec3] = useAsistencia()
  const { userIDB2C } = useAuthentication()
  const history = useHistory()
  const [loadingPDF, setLoadingPDF] = useState(false)
  const { assistanceForm } = useFormTechnicalAssistance()
  const [sec, setSec] = useState(1)

  const cancelForm = () => {
    history.push(ROUTES.IFIFORMSSENT.pathname)
  }

  const next1 = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    setSec(1)
  }

  const next2 = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    setSec(2)
  }

  const next3 = () => {
    setEnableSec3(true)
    dispatch({ type: 'SET_STATE', payload: 3 })
    setSec(3)
  }

  const dowloadReport = async () => {
    try {
      let response
      setLoadingPDF(true)
      if (assistanceForm.IdBeneficiaryType === 2)
        response = await reportCapacityBuildingIFI(
          assistanceForm.IdTechnicalAssistanceAnswer,
          userIDB2C,
        )

      if (
        assistanceForm.IdBeneficiaryType === 1 &&
        assistanceForm.IdTechnicalAssistanceType === 4
      )
        response = await reportTechnicalAssistancePreinvestment(
          assistanceForm.IdTechnicalAssistanceAnswer,
          userIDB2C,
        )

      if (
        assistanceForm.IdBeneficiaryType === 3 &&
        assistanceForm.IdTechnicalAssistanceType === 4
      )
        response = await reportTechnicalAssistancePreinvestmentGroupMipyme(
          assistanceForm.IdTechnicalAssistanceAnswer,
          userIDB2C,
        )

      if (
        assistanceForm.IdBeneficiaryType === 1 &&
        assistanceForm.IdTechnicalAssistanceType === 5
      )
        response = await reportCapacityBuilding(
          assistanceForm.IdTechnicalAssistanceAnswer,
          userIDB2C,
        )

      if (
        assistanceForm.IdBeneficiaryType === 3 &&
        assistanceForm.IdTechnicalAssistanceType === 5
      )
        response = await reportCapacityBuildingGroupMipyme(
          assistanceForm.IdTechnicalAssistanceAnswer,
          userIDB2C,
        )

      if (response.Success) {
        for (
          let j = 0;
          j < response.Data.ReportTechnicalAssistanceAnswers.length;
          j++
        ) {
          const byteCharacters = atob(
            response.Data.ReportTechnicalAssistanceAnswers[j].FileContents,
          )
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const filename =
            response.Data.ReportTechnicalAssistanceAnswers[j].FileName.split(
              '.',
            ).shift()
          const blob = new Blob([byteArray], { type: 'application/pdf' })
          const link = document.createElement('a')

          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click()
          setLoadingPDF(false)
        }
      }
    } catch (error) {
      console.log(error)
      setLoadingPDF(false)
    }
  }

  return (
    <>
      <div
        id="wizard-form"
        style={{
          overflow: 'hidden',
          backgroundColor: 'white',
          boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
        }}
      >
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              {/* <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">
                  Formulario Elegibilidad de Inversiones para Financiamiento
                </label>
                <span className="formIDDetail">
                  Código Formulario:#{' '}
                  {EligibilityForm.IdElegibilityAnswer
                    ? EligibilityForm.IdElegibilityAnswer
                    : ''}
                </span>
              </div> */}
            </Grid>
          </Grid>

          <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                data-for="exitPop"
                onClick={() => cancelForm()}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>

            <Grid item>
              <div onClick={() => dowloadReport()} data-tip data-for="savePop">
                {/* <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} /> */}

                <LoadingButton
                  loadingPosition="start"
                  variant="contained"
                  startIcon={
                    <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} />
                  }
                  loading={loadingPDF}
                  style={{
                    backgroundColor: '#5cb85c',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                ></LoadingButton>
              </div>
              <ReactTooltip
                id="savePop"
                effect="solid"
                backgroundColor="#5cb85c"
              >
                <span>Descargar</span>
              </ReactTooltip>
            </Grid>
          </Grid>
        </div>

        <Grid
          container
          spacing={1}
          style={{ marginTop: '18px', marginBottom: '36px' }}
        >
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 1
                ? // step === 1
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
            onClick={() => next1()}
          >
            <label style={{ cursor: 'pointer' }}>SECCIÓN 1</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 2
                ? // step === 1
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
            onClick={() => next2()}
          >
            <label style={{ cursor: 'pointer' }}>SECCIÓN 2</label>
          </Grid>
          {enableSec3 ? (
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 3
                  ? // step === 1
                    `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
              onClick={() => next3()}
            >
              <label style={{ cursor: 'pointer' }}>SECCIÓN 3</label>
            </Grid>
          ) : (
            ''
          )}
        </Grid>

        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '80%',
                height: '80vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          {sec === 1 ? (
            <StepWizard initialStep={1}>
              <AsistenciaSeccion1View idForm={idForm} />
              <AsistenciaSeccion2View idForm={idForm} />
              {enableSec3 ? <AsistenciaSeccion3View idForm={idForm} /> : ''}
            </StepWizard>
          ) : (
            ''
          )}

          {sec === 2 ? (
            <StepWizard initialStep={2}>
              <AsistenciaSeccion1View idForm={idForm} />
              <AsistenciaSeccion2View idForm={idForm} />
              {enableSec3 ? <AsistenciaSeccion3View idForm={idForm} /> : ''}
            </StepWizard>
          ) : (
            ''
          )}

          {sec === 3 ? (
            <StepWizard initialStep={3}>
              <AsistenciaSeccion1View idForm={idForm} />
              <AsistenciaSeccion2View idForm={idForm} />
              {enableSec3 ? <AsistenciaSeccion3View idForm={idForm} /> : ''}
            </StepWizard>
          ) : (
            ''
          )}
        </Suspense>
      </div>
    </>
  )
}

export default AsistenciaTecnicaFormView
